export default __webpack_public_path__ + "static/media/saveInk.0579b4ce.jpeg";